<template>
  <v-navigation-drawer app mobile-break-point="600">

    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
            Respirar de Ouvido
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-divider></v-divider>

    <v-list dense class="pt-0">
      <v-list-tile
        v-for="item in items"
        :key="item.title"
        :to="item.destination"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>

      </v-list-tile>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
export default {
  data: function () {
    return {
      items: [
        // {
        //   title: 'Dashboard',
        //   icon: 'dashboard',
        //   destination: '/'
        // },
        {
          title: 'Albums',
          icon: 'album',
          destination: '/albums'
        },
        {
          title: 'Newsletter',
          icon: 'local_post_office',
          destination: '/newsletter'
        },
        {
          title: 'Textos',
          icon: 'text_snippet',
          destination: '/content'
        },
        {
          title: 'Páginas',
          icon: 'description',
          destination: '/pages'
        }
      ],
      right: null
    }
  }
}
</script>

<style lang="css" scoped>
</style>
